import { useBrand } from '../../contexts/BrandingContext';
import { useAuth } from '../../contexts/AuthContext';
import { FooterStatic } from './FooterStatic';
import { useTenant } from '../../contexts/TenantContext';
import SaasFooter from './saas/SaasFooter';

export function Footer() {
  const { branding } = useBrand();
  const { isAuthenticated } = useAuth();
  const { isAddEditHost } = useTenant();

  // If we have branding but aren't authenticated yet, show appropriate footer
  if (!isAuthenticated) {
    // If the flag is true, use the same footer as authenticated users
    if (branding?.usecustomheaderandfooterunauthenticated) {
      if (branding?.customfooter) {
        return (
          <div dangerouslySetInnerHTML={{ __html: branding.customfooter }} />
        );
      }
      return <FooterStatic />; // Default footer when sharing with authenticated
    }

    // Otherwise, use the dedicated unauthenticated footer if available
    if (branding?.customunauthenticatedfooter) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: branding.customunauthenticatedfooter,
          }}
        />
      );
    }

    return null; // No footer for unauthenticated users without custom content
  }

  // For authenticated users: use customfooter if available, otherwise use static footer
  if (branding?.customfooter) {
    return <div dangerouslySetInnerHTML={{ __html: branding.customfooter }} />;
  }

  if (isAddEditHost()) {
    return <SaasFooter />;
  }

  return <FooterStatic />; // Default footer for authenticated users
}
